import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible, formatDateFromISO, formatTimeSlot } from "@utils/index";
import CalendarIcon from "@public/images/Calender.svg"
import {
  Card,
  IconContainer,
  ContentContainer,
  LabelText,
  DateTimeText,
} from "./styles";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const ScheduleDetailsCard = (props: any) => {
  const { is_visible, selectedDate, selectedSlot, label } = props;
  if (!is_visible) return <></>;

  const formattedDate = formatDateFromISO(selectedDate || "");
  const formattedTime = formatTimeSlot(selectedSlot || "");
  if (!selectedDate || !selectedSlot) {
    return <></>;
  }
  return (
    <Card>
      <IconContainer>
        <CalendarIcon
          styles={{
            width: "24px",
            height: "24px"
          }}
          actions={{}}
        />
      </IconContainer>
      <ContentContainer>
        <LabelText>{label}</LabelText>
        <DateTimeText>
          {formattedDate} at {formattedTime}
        </DateTimeText>
      </ContentContainer>
    </Card>
  );
};

export default connect(mapStateToProps)(ScheduleDetailsCard);

